import { z } from "zod";
import { apiIntIdSchema } from "./ids.js";
import { storageQuotaBytesSchema } from "./system-config-contracts.js";
/**
 * Per-organization snapshot of platform defaults, later editable by Super Admin.
 * NULL on a quantitative limit means Unlimited, including storageQuotaBytes.
 * SystemConfig.defaultStorageQuotaBytes stays finite in Phase 3A; this field does not.
 * A missing row does not mean Unlimited.
 * There is no data-export flag. Export authorization is a separate future design.
 * Phase 3A stores the row. It does not enforce it.
 */
export const organizationEntitlementResponseSchema = z.object({
    organizationId: apiIntIdSchema,
    contactsLimit: z.number().int().nullable(),
    teamMembersLimit: z.number().int().nullable(),
    storageQuotaBytes: z.string().nullable(),
    whatsappEnabled: z.boolean(),
    facebookEnabled: z.boolean(),
    instagramEnabled: z.boolean(),
});
/**
 * Partial update of one organization. Omitted keys are unchanged.
 * Explicit null on a quantitative limit means Unlimited.
 * Unknown keys are rejected. Does not change SystemConfig or any other organization.
 */
export const updateOrganizationEntitlementRequestSchema = z
    .object({
    contactsLimit: z.number().int().min(0).nullable().optional(),
    teamMembersLimit: z.number().int().min(1).nullable().optional(),
    storageQuotaBytes: storageQuotaBytesSchema.nullable().optional(),
    whatsappEnabled: z.boolean().optional(),
    facebookEnabled: z.boolean().optional(),
    instagramEnabled: z.boolean().optional(),
})
    .strict();
//# sourceMappingURL=organization-entitlement-contracts.js.map